<template>
  <v-card flat rounded="lg" class="mr-4" :width="width" :outlined="isPdf ? false : true">
    <v-list-item>
      <IconContainer size="50" :imagePath="image" color="grey"/>

      <v-list-item-content class="ml-2">
        <v-list-item-subtitle>{{ title }}
          <v-tooltip v-if="tooltipText && !isPdf" bottom max-width="500">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" class="ml-5" size="18" color="#96A4B9">
              mdi-information-outline
            </v-icon>
          </template>
          <span>{{tooltipText}}</span>
        </v-tooltip></v-list-item-subtitle>
        <v-list-item-title class="text-h6">{{ value.toLocaleString() }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
import IconContainer from "@/components/IconContainer";

export default {
  props: {
    title: { type: String, default: "" },
    value: { type: Number, default: 0 },
    image: { type: String, default: "" },
    width: { type: String, default: "100%" },
    tooltipText: { type: String, default: "" },
    isPdf: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    IconContainer,
  },
};
</script>

<style>
</style>